<template>
	<div class="c-quotes-index">
		<loading-dots v-if="loading"></loading-dots>
		<div class="o-grid" v-if="!loading">
			<template v-for="item in sortedItems">
				<template v-if="item[2]">
					<div class="o-grid__item o-grid__item--flex h-two-thirds h-tablet-one-whole h-phone-one-whole">
						<div class="o-grid">
							<div class="o-grid__item o-grid__item--flex h-one-half h-phone-one-whole" v-if="item[0]">
								<quote-block :item="item[0]"></quote-block>
							</div>
							<div class="o-grid__item o-grid__item--flex h-one-half h-phone-one-whole" v-if="item[1]">
								<quote-block :item="item[1]"></quote-block>
							</div>
							<div class="o-grid__item o-grid__item--flex h-one-whole" v-if="item[2]">
								<quote-block :item="item[2]" ></quote-block>
							</div>
						</div>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole" v-if="item[3]">
						<quote-block :item="item[3] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole" v-if="item[4]">
						<quote-block :item="item[4] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole" v-if="item[5]">
						<quote-block :item="item[5]"></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole" v-if="item[6]">
						<quote-block :item="item[6]"></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-two-thirds h-tablet-one-whole h-phone-one-whole">
						<div class="o-grid">
							<div class="o-grid__item o-grid__item--flex h-one-half h-phone-one-whole" v-if="item[7]">
								<quote-block :item="item[7]"></quote-block>
							</div>
							<div class="o-grid__item o-grid__item--flex h-one-half h-phone-one-whole" v-if="item[8]">
								<quote-block :item="item[8]"></quote-block>
							</div>
							<div class="o-grid__item o-grid__item--flex h-one-whole" v-if="item[9]">
								<quote-block :item="item[9]" ></quote-block>
							</div>
						</div>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole" v-if="item[10]">
						<quote-block :item="item[10] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole" v-if="item[11]">
						<quote-block :item="item[11] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole" v-if="item[12]">
						<quote-block :item="item[12]"></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole" v-if="item[13]">
						<quote-block :item="item[13]"></quote-block>
					</div>
				</template>
				<template v-else>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[0] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[1] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[3] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[4] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[5]"></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[6]"></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[7] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[8] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[10] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[11] "></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[12]"></quote-block>
					</div>
					<div class="o-grid__item o-grid__item--flex h-one-third h-tablet-one-half h-phone-one-whole">
						<quote-block :item="item[13]"></quote-block>
					</div>
				</template>
			</template>

			<div class="o-grid__item h-one-whole" v-if="showButton">
				<div class="h-text--center">
					<button class="c-btn c-btn--brand" @click.prevent="loadItems()">
						<span class="c-btn__loading" v-bind:class="{isLoading: this.loadingButton}">
							Show more
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import quoteBlock from './quote-block.vue';
	import loadingDots from './loading-dots.vue';
	import axios from 'axios';

	export default {
		name: 'quotes-index',
		data() {
			return {
				loading              : true,
				loadingButton        : false,
				quotes               : [],
				quotesPage  		     : 1,
				quotesWithImages     : [],
				quotesWithImagesPage : 1,
				sortedItems          : [],
				quotesWithImagesLoaded  : false,
				quotesLoaded				 : false,
				loadedSections       : 0
			}
		},
		components : {
			quoteBlock,
			loadingDots,
		},
		props: {
			id: {
				type: Number
			},
			active: {
				type: Boolean
			}
		},
		computed:{
			showButton() {
				return !(this.quotesWithImagesLoaded && this.quotesLoaded && this.quotesWithImages.length == 0 && this.quotes.length == 0)
			}
		},
		mounted() {
			var self = this;
			axios.all([
				axios.get('/api/quotes.json?relatedTo=' + self.id, { crossdomain: true }), axios.get('/api/quotes.json?relatedTo='+ self.id + '&withImages=true', { crossdomain: true})
			])
			.then(axios.spread(function (quotesResponse, quotesWithImageResponse) {
				self.quotes  = quotesResponse.data.data;
				self.quotesWithImages  = quotesWithImageResponse.data.data;

				if (quotesResponse.data.meta.pagination.current_page == quotesResponse.data.meta.pagination.total_pages || quotesResponse.data.meta.pagination.total_pages == 0) {
					self.quotesLoaded = true
				}

				if (quotesWithImageResponse.data.meta.pagination.current_page == quotesWithImageResponse.data.meta.pagination.total_pages || quotesWithImageResponse.data.meta.pagination.total_pages == 0) {
					self.quotesWithImagesLoaded = true
				}

				self.loadItems()
				self.loading = false;
			}));
		},
		methods: {
			getQuotes() {
				axios.get('/api/quotes.json?relatedTo=' + this.id, { crossdomain: true })
			},
			getQuotesWithImages() {
				axios.get('/api/quotes.json?relatedTo='+ this.id + '&withImages=true', { crossdomain: true })
			},
			loadItems() {
				var self = this;
				self.loadingButton = true;
				var groupedItems = [];

				function quoteLoop(i){
				   if(i === undefined) {
				     i = 0;
					 }
				   if(i > 13) {
						 self.$set(self.sortedItems, self.loadedSections, groupedItems)
						 self.loadingButton = false;

					 	 self.loadedSections++
					 }
					 else if (i === 2 || i === 9 ) {
						if (self.quotesWithImages.length === 0) {
							if (!self.quotesWithImagesLoaded) {
								self.quotesWithImagesPage++
								axios.get('/api/quotes.json?relatedTo='+ self.id + '&page=' + self.quotesWithImagesPage + '&withImages=true', { crossdomain: true }).then((response) => {
									self.quotesWithImages = response.data.data;
									groupedItems.push(self.quotesWithImages.splice(0, 1)[0]);
									i++
									if (response.data.meta.pagination.current_page == response.data.meta.pagination.total_pages) {
										self.quotesWithImagesLoaded = true
									}
									quoteLoop(i)
								})
							}
							else {
								groupedItems.push('');
								i++
								quoteLoop(i)
							}
 						}
 						else {
 							groupedItems.push(self.quotesWithImages.splice(0, 1)[0]);
							i++
							quoteLoop(i)
 						}
 					}
 					else {
 						if (self.quotes.length === 0) {
							if (!self.quotesLoaded) {
	 							self.quotesPage++
	 							axios.get('/api/quotes.json?relatedTo='+ self.id + '&page=' + self.quotesPage, { crossdomain: true }).then((response) => {
	 								self.quotes = response.data.data;
	 								groupedItems.push(self.quotes.splice(0, 1)[0]);
									if (response.data.meta.pagination.current_page == response.data.meta.pagination.total_pages) {
										self.quotesLoaded = true
									}
									i++
									quoteLoop(i)
	 							})
							}
							else {
								groupedItems.push('');
								i++
								quoteLoop(i)
							}
 						}
 						else {
 							groupedItems.push(self.quotes.splice(0, 1)[0]);
							i++
							quoteLoop(i)
 						}
 					}
				};

				quoteLoop()
			}
		},
		watch: {
			active: function(state) {

				var self = this;

				if (!self.sortedItems.length && state) {

					axios.all([
						axios.get('/api/quotes.json?relatedTo='+ self.id, { crossdomain: true }), axios.get('/api/quotes.json?relatedTo='+ self.id + '&withImages=true', { crossdomain: true})
					])
				  .then(axios.spread(function (quotesResponse, quotesWithImageResponse) {
						self.quotes  = quotesResponse.data.data;
						self.quotesWithImages  = quotesWithImageResponse.data.data;

						self.loadItems()
				  }));
				}
			}
		}
	};
</script>



// WEBPACK FOOTER //
// quote-index.vue?0f852eef